<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Campuses'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Campuses',
            includeDeleteAction: false,
            actions: [
                {
                    icon: 'far fa-star',
                    method: 'setAsDefault',
                    where: {
                        isDefault: {
                            value: false
                        }
                    }
                },
                {
                    icon: 'far fa-trash-alt',
                    method: 'showDeleteModal',
                    where: {
                        isDefault: {
                            value: false
                        }
                    }
                }
            ]
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'phone',
                    width: '150px'
                },
                {
                    value: 'email',
                    width: '150px'
                },
                {
                    text: 'Default',
                    value: 'isDefault',
                    type: 'boolean',
                    width: '50px',
                    filter: v => (v ? 'Yes' : '-')
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'campuses/index',
            deleteItem: 'campuses/destroy',
            changeDefault: 'campuses/changeDefault'
        }),

        onRowClick({ id }) {
            this.$router.push(`/campuses/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/campuses/add');
        },

        async setAsDefault(id, index) {
            try {
                await this.changeDefault(id);

                this.items = this.items.map((campus, campusIndex) => ({
                    ...campus,
                    isDefault: index === campusIndex
                }));

                this.$toaster('Default campus changed.');
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
